import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import _ from 'lodash';
import {
    Button, Form, Input, message, Radio, DatePicker, InputNumber
} from 'antd';
import { formItemLayout, tailLayout } from './ModalLayout';
import FormUploadFile from './FormUploadFile';
import * as Service from '../core/Service';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

const VehicleForm = (props) => {
  const {t} = useTranslation();

  const [form] = Form.useForm();
  const [formData, setFormData] = useState({});
  const [imageURL, setImageURL] = useState("");
  const [fileinfo, setFileinfo] = useState({});

  const {
    selectedRecord,
    openModal
  } = props;

  const ORIGIN = useSelector(
    (state) => state.app.origin
  );

  useEffect(() => {
    console.log('reset data')
    form.resetFields();
    setImageURL('')
    setFileinfo({})


    let data = _.clone(selectedRecord);
    if (selectedRecord.filepath) {
      console.log(selectedRecord);
      console.log(`${ORIGIN}/${selectedRecord.filepath}`);
      setImageURL(`${ORIGIN}/${selectedRecord.filepath}`);
      setFileinfo({filepath: selectedRecord.filepath});
      data.files = data.photo_image;
      setFormData(data);
      form.setFieldsValue(data);
    }



    if (selectedRecord.start_date && selectedRecord.end_date) {
      data.start_date = moment.unix(data.start_date);
      data.end_date = moment.unix(data.end_date);
      setFormData(data);
      form.setFieldsValue(data);
    }
    // setFormData(selectedRecord);
  }, [ORIGIN, form, selectedRecord]);

  useEffect(() => {
    form.setFieldsValue(formData);
  }, [form, formData]);

  const onFinish = async (formObj) => {
    let method = `POST`;
    let endpoint = `/api/advertising`;

    console.log("ad_id", formData.ad_id);
    let bodyObj = _.clone(formObj);
    bodyObj.filepath = fileinfo.filepath;
    bodyObj.start_date = moment(bodyObj.start_date).startOf('date').unix();
    bodyObj.end_date = moment(bodyObj.end_date).endOf('date').unix();
    if (formData.ad_id > 0) {
      bodyObj.ad_id = formData.ad_id;
      method = `PUT`;
    }

    try {
      let resp = await Service.call(method, endpoint, bodyObj);
      if (resp.errorMessage) {
        message.error(resp.errorMessage);
        return;
      }
      message.success(t('common.success'));
      form.resetFields();
      setImageURL('')
      setFileinfo({})
      return openModal(false);
    } catch (error) {
      form.resetFields();
      setImageURL('')
      setFileinfo({})
      console.log(error);
    }
  }

  const uploadOnChange = (info) => {
    const { status, response } = info.file;
    // console.log(status);
    // console.log(response);
    if (status === "done") {
      message.destroy();
      if (response.status > 0) {
        message.success(t('common.upload_success'));
        let data = {
          filename: info.file.response.filename,
          filepath: info.file.response.filepath,
        };

        let path = "../../" + info.file.response.filepath;
        setImageURL(path);
        setFileinfo(data);
      } else {
        message.error(t('common.upload_fail'));
      }
    }
  };

  return (
    <Form
      {...formItemLayout}
      form={form}
      onFinish={onFinish}
      initialValues={formData}
    >
      <Form.Item
        name="name"
        label={t('ad.ad_name')}
        rules={[{ required: true, message: t('common.please_input') }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="files"
        label={t('ad.ad_file')}
      >
        <FormUploadFile
          data={{ scope: "private" }}
          onChange={uploadOnChange}
          imageURL={imageURL}
          beforeUpload={
            (file) => {
              const acceptMimeTypes = ['image/png', 'image/jpeg'];
              if (!_.includes(acceptMimeTypes, file.type)) {
                message.error(t('common.accepted_format'));
                return false;
              }
              const fileSize = file.size / 1024 / 1024;
              if (fileSize > 1) {
                message.error(t('ad.image_too_large'));
                return false;
              }
              message.success(t('common.uploading'));
              return true;
            }
          }
        />
      </Form.Item>
      <Form.Item
        label={t('common.is_active')}
        name={t('common.is_active')}
      >
        <Radio.Group>
          <Radio value={1}>{t('common.yes')}</Radio>
          <Radio value={0}>{t('common.no')}</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        label={t('common.start_time')}
        name="start_date"
      >
        <DatePicker 
          showTime
        />
      </Form.Item>
      <Form.Item
        label={t('common.end_time')}
        name="end_date"
      >
        <DatePicker 
          showTime
        />
      </Form.Item>
      <Form.Item
        label={t('ad.ad_priority')}
        name="priority"
      >
        <InputNumber max={999} min={-999} defaultValue={0}/>
      </Form.Item>
      <Form.Item {...tailLayout}>
        <Button
          type="primary"
          htmlType="submit"
        >
          {t('common.submit')}
        </Button>
      </Form.Item>
    </Form >
  );
}

export default VehicleForm;
